module.exports = __webpack_public_path__ + "static/metalogo-f19e86d8f8d4977b704e751b08f461b4.png";